// Reusable vector brand marks for Qauntum International.
// Pure geometry (no font dependency) so it stays crisp at any size.

export const Monogram = ({ size = 48, color = "#c2a878", className = "", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Qauntum monogram"
    {...props}
  >
    <circle cx="60" cy="60" r="50" stroke={color} strokeWidth="3.5" />
    <circle cx="60" cy="60" r="41" stroke={color} strokeWidth="1" opacity="0.45" />
    <line x1="69" y1="69" x2="104" y2="104" stroke={color} strokeWidth="6.5" strokeLinecap="round" />
  </svg>
);

// Horizontal lockup: monogram + wordmark. Uses live webfont on the site.
export const LogoLockup = ({
  height = 40,
  color = "#f8f8f8",
  accent = "#c2a878",
  className = "",
}) => (
  <div className={`flex items-center gap-3 ${className}`} aria-label="Qauntum International">
    <Monogram size={height} color={accent} />
    <div className="flex flex-col leading-none">
      <span className="font-serif-q tracking-tight" style={{ color, fontSize: height * 0.62 }}>
        Qauntum
      </span>
      <span
        className="uppercase"
        style={{
          color: accent,
          fontSize: height * 0.2,
          letterSpacing: "0.32em",
          marginTop: height * 0.05,
        }}
      >
        International
      </span>
    </div>
  </div>
);
